import * as React from 'react';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import { useCart } from '../../../context/Cart/context.js';

const DeliveryIndicatorContainer = ({ lineItemId  })=>{
    const settings = useCartSettings();
    const { cart  } = useCart();
    const lineItem1 = cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>lineItem.id === lineItemId
    )[0];
    if (!lineItem1) {
        return null;
    }
    const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([
        lineItem1
    ]);
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "short",
        availability: lineItem1.availability ? [
            lineItem1.availability
        ] : [],
        deliveryResolver: deliveryResolver
    });
};

export { DeliveryIndicatorContainer };
//# sourceMappingURL=DeliveryIndicatorContainer.js.map
